import { apiService } from "../../../../../../../../services/apiService";
import { apiServiceConstants } from "../../../../../../../../constants/apiService.constants";
import { utilService } from "../../../../../../../../services/utilService";
import {
  MessageData,
  FromUser,
  messageResultInterface,
  RespMessageModel,
} from "../SBoardMessage/SBoardMessage.modal";

const getMessage = async (params: any) => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/message/?reg_code=${utilService.getNetwork()}&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`,

      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const messageListResp = res as RespMessageModel;
      var messageListResponse = [];
      if (messageListResp.result) {
        messageListResponse = setSBoardMessage(messageListResp.result?.[0]);
      }

      const result: messageResultInterface = {
        isSuccess: true,
        message: messageListResp.message,
        status: messageListResp.status,
        result: messageListResponse,
      };
      
      return result;
    })
    .catch((err) => {
      const result: messageResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const funcremoveMessageCard = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/message/?reg_code=${utilService.getNetwork()}&pid=${params.pid}`,

      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const messageListResp = res as RespMessageModel;
      var messageListResponse = [];
      if (messageListResp.result) {
        messageListResponse = setSBoardMessage(messageListResp.result?.[0]);
      }

      const result: messageResultInterface = {
        isSuccess: true,
        message: messageListResp.message,
        status: messageListResp.status,
        result: messageListResponse,
      };
   
      return result;
    })
    .catch((err) => {
      const result: messageResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setSBoardMessage = (payload: any): any => {
  let messageListArray = {
    count: payload.count,
    next: payload.next,
    previous: payload.previous,
    data: mapData(payload.data),
  };

  return messageListArray;
};

const mapData = (mapData: Array<MessageData>) => {
  var mapDataObject: any;
  if (mapData == null) {
    return [];
  } else {
    let mapDataArray: Array<MessageData> = [];

    mapData.map((items: any) => {
      mapDataObject = {
        createdOn: items.created_on,
        id: items.id,
        message: items.message,
        FromUser: mapFromUser(items.from_user),
      };
      mapDataArray.push(mapDataObject);
    });
    return mapDataArray;
  }
};
const mapFromUser = (userData: FromUser) => {
  var fromuserObject = {
    firstName: userData.first_name,
    lastName: userData.last_name,
    profilePic: mapProfilePicData(userData.profile_pic),
  };
  return fromuserObject;
};
const mapProfilePicData = (profilePic: string) => {
  if (profilePic === null) {
    profilePic = "assets/images/defaultProfilePic.png";
  } else {
    const profileUrlFromApi = utilService.getProfilePicUrl(profilePic);
    profilePic = utilService.getBaseUrl() + profileUrlFromApi
  }
  return profilePic;
};

const handleErrorResponse = () => {};

export const getMessageService = {
  getMessage,
  handleErrorResponse,
  funcremoveMessageCard,
};
